module.exports = __webpack_public_path__ + "img/free.a5627ae8.png";